import axios from 'axios';
import global_ from '../views/Global'
import {
    Toast
} from 'vant'

const http = axios.create({
    timeout: 10000,
    baseURL: global_.BASE_URL
});

http.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';

http.interceptors.response.use(
    response => {
        return response;
    },
    error => {
        if (!error['response']) {
            return Promise.reject(error)
        }

        switch (error.response.status) {
            case 422:
                let errors = error.response.data.errors;
                let content = '';
                Object.keys(errors).map(function (key) {
                    let value = errors[key];
                    content = value[0];
                })
                Toast(content);
                break
            case 403:
                Toast(error.response.data.message || '您没有此操作权限！');
                break
            case 401:
                Toast('用戶還未通過認證！');
                break
            case 500:
            case 501:
            case 503:
            default:
                Toast('服務器出了點小問題哦,請稍後再試~！');
        }
        return Promise.reject(error.response);
    }
);

export default http;